import React, { useEffect, useState } from 'react'
import MasterPage from 'components/MasterPage'
import { Card, Col, Row, Button, Table, Spinner } from 'react-bootstrap'
import ListingReportsInvoices from 'components/ListingReportsInvoices'
import { api } from 'services'
import { DashboardOutlined } from '@material-ui/icons'
import { formatDate, parseDateBR } from 'helpers/date'
import convertToAscii from 'helpers/ConvertToASCII'
import ReactDOMServer from 'react-dom/server'

const ReportInvoices = () => {
  const defaultFilters = {
    search: '',
    per_page: 10,
    page: 1,
  };

  const [filters, setFilters] = useState(defaultFilters);
  const [invoices, setInvoices] = useState([])
  const [pagination, setPagination] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [isExport, setIsExport] = useState(false)

  useEffect(() => {
    getInvoices()
  }, [filters])

  const getInvoices = async () => {
    const response = await fetchInvoices(filters)
    const { data, from, to, total, current_page, per_page } = response.data

    setInvoices(formatData(data))
    setPagination({ from, to, total, current_page, per_page })
    setIsLoading(false)
  }

  const fetchInvoices = (_filters) => {
    return api.get('reports-invoices', {
      params: {
        ..._filters,
        __date_from: filters.date_from ? formatDate(filters.date_from) : "",
        __date_to: filters.date_to ? formatDate(filters.date_to) : ""
      }
    })
  }

  const colConfig = {
    headerStyle: {
      width: '4%',
      textAlign: 'center'
    },
    style: {
      textAlign: 'center',
      fontSize: '15px'
    }
  }

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      ...colConfig
    }, {
      dataField: 'service_provider',
      text: 'Fornecedor',
      ...colConfig
    }, {
      dataField: 'value',
      text: 'Valor',
      ...colConfig
    }, {
      dataField: 'invoice_number',
      text: 'Nº da Nota',
      ...colConfig
    }, {
      dataField: 'payment_method',
      text: 'Tipo de Pagamento',
      ...colConfig
    }, {
      dataField: 'due_date',
      text: 'Vencimento',
      ...colConfig
    }, {
      dataField: 'creator',
      text: 'Analista',
      ...colConfig
    }, {
      dataField: 'company',
      text: 'Fabricante',
      ...colConfig
    }, {
      dataField: 'is_advance',
      text: 'Adiantamento',
      ...colConfig
    }, {
      dataField: 'description',
      text: 'Descrição',
      ...colConfig
    }, {
      dataField: 'created_at',
      text: 'Data de Criação',
      ...colConfig
    },
  ];

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const exportData = async () => {
    setIsExport(true)
    const format = (table, fileName) => {
      return (`
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>${fileName || 'Worksheet'}</x:Name>
                        <x:WorksheetOptions>
                          <x:DisplayGridlines/>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
          <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
        </head>
        <body>
          ${convertToAscii(ReactDOMServer.renderToString(table), [160])}
        </body>
      </html>`
      )
    }

    const buildTable = data => {
      return (
        <Table>
          <thead>
            {columns.map(col => (
              <th>{col.text}</th>
            ))}
          </thead>
          <tbody>
            {data.map(d => {
              return (
                <tr>
                  {columns.map(col => {
                    return (
                      <td>{d[col.dataField]}</td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      )
    }

    var _filters = {...filters}

    delete _filters.per_page
    delete _filters.page

    const response = await fetchInvoices(_filters)
    const { data } = response.data

    let table_div = format(buildTable(formatData(data)), "report_invoices")
    var a = document.createElement('a')
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8'
    var table_html = escape(table_div)
    a.href = data_type + ', ' + table_html
    a.download = 'report_invoices.xls'
    a.click();
    setIsExport(false)
  }

  const formatData = data => {
    const _data = data.map(invoice => ({
      id: invoice.id,
      service_provider: invoice.service_provider ?? "--",
      value: invoice.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
      invoice_number: invoice.invoice_number ?? "--",
      payment_method: invoice.payment_method_id == 1 ? "Boleto" : "Transferencia Bancária",
      due_date: invoice.due_date ? parseDateBR(invoice.due_date) : "--",
      creator: invoice.creator ?? "--",
      company: invoice.company,
      is_advance: invoice.is_advance ? "Sim" : "Não",
      description: invoice.description ?? "--",
      created_at: parseDateBR(invoice.created_at)
    }))

    return _data
  }

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">Relatório de Notas</h4>
          </Col>
          <Col md="12" className="mb-2">
            <Button
              onClick={() => exportData()}
              disabled={isExport}
            >
              Exportar Tabela
              {' '}
              <Spinner
                animation="border"
                role="status"
                size="sm"
                style={!isExport ? { display: 'none' } : {}}
              />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <ListingReportsInvoices
                  data={invoices}
                  pagination={pagination}
                  handleFilterChange={handleFilterChange}
                  stateFilters={filters}
                  setFilters={setFilters}
                  columns={columns}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  )
}

export default MasterPage(ReportInvoices)